import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

function Message() {
    const { handleChange, state } = useContext(GiftOrderContext);
    const { t } = useTranslation('gift');

    return (
        <Column fullWidth spacing={1}>
            <Text color={colors.textSecondary} fontWeight='medium' size='body-short'>
                {t('giftOrder.messageTitle')}
            </Text>
            <TextField
                placeholder={t('giftOrder.messagePlaceholder')}
                onChange={handleChange}
                value={state.message}
                as='textarea'
                name='message'
                rows={3}
                maxLength={50}
                showLength
            />
        </Column>
    );
}

export default Message;
